import Typography from "@mui/material/Typography";
import { SxProps } from "@mui/material/styles";

import { ProductCategory } from "services/types/product-categories.type";

export function productCategoryName(category: ProductCategory) {
  return category.is_archived ? `${category.name} (Archived)` : category.name;
}

interface ProductCategoryLabelProps {
  category?: ProductCategory | null;
  // "overline" sits above a device name (chart header, device cards);
  // "inline" trails a row in a list or picker.
  variant?: "inline" | "overline";
  sx?: SxProps;
}

// Plain text, never a chip: chips and colours already mean patient tags.
export default function ProductCategoryLabel({
  category,
  variant = "inline",
  sx
}: ProductCategoryLabelProps) {
  if (!category) return null;

  return (
    <Typography
      component="span"
      data-testid="product-category-label"
      variant={variant === "overline" ? "overline" : "body2"}
      color="text.secondary"
      // A category is often a longer name plus a suffix ("Hearing Aids TPA"), so the
      // narrow overline wraps rather than cutting off the part that tells two apart.
      noWrap={variant === "inline"}
      title={productCategoryName(category)}
      sx={{
        display: "block",
        maxWidth: 240,
        lineHeight: variant === "overline" ? 1.4 : undefined,
        fontStyle: category.is_archived ? "italic" : undefined,
        ...sx
      }}
    >
      {productCategoryName(category)}
    </Typography>
  );
}
